export default __webpack_public_path__ + "locales/uk-UA/ConvertDialog.json?hash=f510b257fbc9d1fcfbfc4cc43ee95acf";